import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/user';
import { CircularProgress } from '@mui/material';

const AdminRoute = () => {
  const user = useUser();
  const adminId = process.env.REACT_APP_ADMIN_USER_ID;

  if (user.loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#090808',
      }}>
        <CircularProgress sx={{ color: '#F4B942' }} />
      </div>
    );
  }

  if (!user.current) {
    return <Navigate to="/auth" />;
  }

  if (user.current.id !== adminId) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};

export default AdminRoute;
